module.exports = __webpack_public_path__ + "static/media/a5.51cb4b8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengxiaoyue/a5.mp3
// module id = ve5q
// module chunks = 0